const axios = require('axios');
const mapDataToFormData = (data, formData = null) => {
    if (!formData) {
        formData = new FormData();
    }
    Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
    });
    return formData;
};
export const submitColumnSettings = (data) => {
    return axios.post(ajaxurl, mapDataToFormData({
        action: 'ac-columns',
        id: 'save',
        _ajax_nonce: AC._ajax_nonce,
        data: JSON.stringify(data)
    }));
};
export const switchColumnType = (type, list_screen = AC.list_screen) => {
    return axios.post(ajaxurl, mapDataToFormData({
        _ajax_nonce: AC._ajax_nonce,
        action: 'ac-columns',
        current_original_columns: JSON.stringify(AC_SERVICES.getService('Form').getOriginalColumns().map((e) => e.getName())),
        id: 'select',
        list_screen: list_screen,
        type: type,
    }));
};
export const refreshColumn = (name, data, list_screen = AC.list_screen) => {
    return axios.post(ajaxurl, mapDataToFormData({
        _ajax_nonce: AC._ajax_nonce,
        action: 'ac-columns',
        column_name: name,
        data: data,
        id: 'refresh',
        list_screen: list_screen,
    }));
};
